<template>
  <div
    v-if="compareOpen"
    id="compare-modal"
    class="cmp-overlay"
    style="display: flex"
    @click.self="closeCompare"
  >
    <div class="cmp-modal">
      <!-- Header -->
      <div class="cmp-header">
        <div class="cmp-header-left">
          <span style="font-size: 18px">⚡</span>
          <span class="cmp-header-title">Compare Reports</span>
        </div>
        <button class="modal-close" @click="closeCompare">✕</button>
      </div>

      <!-- Department Tabs -->
      <div class="cmp-dept-tabs">
        <button
          v-for="(dept, i) in CMP_DEPT_TABS"
          :key="dept.id"
          class="cmp-dept-tab"
          :class="{ active: cmpActiveDept === i }"
          :style="{ '--dept-color': dept.color }"
          @click="switchCmpDept(i)"
        >
          <span class="cmp-dept-icon">{{ dept.icon }}</span>
          <span class="cmp-dept-label">{{ dept.label }}</span>
        </button>
      </div>

      <!-- Sub-report Tabs -->
      <div class="cmp-sub-tabs">
        <button
          v-for="(report, i) in currentCmpDept.reports"
          :key="report.id"
          class="cmp-sub-tab"
          :class="{ active: cmpActiveReport === i }"
          :style="{ '--sub-color': currentCmpDept.color }"
          @click="switchCmpReport(i)"
        >
          {{ report.label }}
        </button>
      </div>

      <!-- Date Bar -->
      <div class="cmp-date-bar">
        <div class="cmp-date-side">
          <span class="cmp-date-label" style="color: var(--accent-green)">◀ SOURCE</span>
          <input
            type="date"
            class="cmp-date-input"
            v-model="cmpDateLeft"
            @change="refreshCompare"
          />
        </div>
        <div class="cmp-vs-divider">
          <span class="cmp-vs-badge">VS</span>
        </div>
        <div class="cmp-date-side" style="justify-content: flex-end">
          <input
            type="date"
            class="cmp-date-input"
            v-model="cmpDateRight"
            @change="refreshCompare"
            style="text-align: right"
          />
          <span class="cmp-date-label" style="color: var(--accent-blue-light)">TARGET ▶</span>
        </div>
      </div>

      <!-- Columns -->
      <div class="cmp-cols">
        <!-- Left / Source column -->
        <div class="cmp-col">
          <div class="cmp-col-header">
            <span class="cmp-col-label" style="color: var(--accent-green)">📄 Source Report</span>
            <span class="cmp-col-date">{{ leftDateLabel }}</span>
          </div>
          <div class="cmp-col-body">
            <div v-if="isLoadingLeft" class="cmp-loading">
              <span class="cmp-loading-spinner"></span> Memuat data...
            </div>
            <div v-else-if="cmpCompared && !leftReport" class="cmp-empty">
              Tidak ada data untuk tanggal ini.
            </div>
            <div v-else-if="cmpCompared && leftReport" class="cmp-md-content">
              <MarkdownRenderer :content="leftReport" />
            </div>
            <div v-else class="cmp-placeholder">
              Klik <strong>Compare</strong> untuk memuat data.
            </div>
          </div>
        </div>

        <!-- Right / Target column -->
        <div class="cmp-col">
          <div class="cmp-col-header">
            <span class="cmp-col-label" style="color: var(--accent-blue-light)">📄 Target Report</span>
            <span class="cmp-col-date">{{ rightDateLabel }}</span>
          </div>
          <div class="cmp-col-body">
            <div v-if="isLoadingRight" class="cmp-loading">
              <span class="cmp-loading-spinner"></span> Memuat data...
            </div>
            <div v-else-if="cmpCompared && !rightReport" class="cmp-empty">
              Tidak ada data untuk tanggal ini.
            </div>
            <div v-else-if="cmpCompared && rightReport" class="cmp-md-content">
              <MarkdownRenderer :content="rightReport" />
            </div>
            <div v-else class="cmp-placeholder">
              Klik <strong>Compare</strong> untuk memuat data.
            </div>
          </div>
        </div>
      </div>

      <!-- Summary Bar -->
      <div
        v-if="cmpCompared"
        class="cmp-summary-bar"
        style="display: block"
        v-html="cmpSummaryHtml"
      ></div>

      <!-- Footer -->
      <div class="cmp-footer">
        <div class="cmp-footer-info">
          <span>📊</span>
          <span v-html="cmpFooterText"></span>
        </div>
        <div class="cmp-footer-actions">
          <button class="cmp-btn primary" :disabled="isLoading" @click="runCompare">
            <template v-if="isLoading">⏳ Loading...</template>
            <template v-else>⚡ Compare</template>
          </button>
          <button class="cmp-btn danger" @click="closeCompare">✕ Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { CMP_DEPT_TABS } from '../data/constants'
import { useCompare } from '../composables/useCompare'
import MarkdownRenderer from './MarkdownRenderer.vue'

const {
  compareOpen,
  cmpDateLeft,
  cmpDateRight,
  cmpActiveDept,
  cmpActiveReport,
  cmpCompared,
  currentCmpDept,
  currentCmpReport,
  leftDateLabel,
  rightDateLabel,
  leftReport,
  rightReport,
  isLoading,
  isLoadingLeft,
  isLoadingRight,
  cmpSummaryHtml,
  cmpFooterText,
  closeCompare,
  switchCmpDept,
  switchCmpReport,
  runCompare,
  refreshCompare,
} = useCompare()
</script>
